import { logError } from "components/providers/logError";
import { useState } from "react";

export const useSessionStorageState = (key: string, initialState: any) => {
    const [state, setState] = useState(() => {
        try {
            return JSON.parse(sessionStorage.getItem(key) || JSON.stringify(initialState));
        } catch (error) {
            logError(error);
            return initialState;
        }
    });

    const setSessionStorageState = (value: any) => {
        try {
            setState(value);
            sessionStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            logError(error);
        }
    };

    return [state, setSessionStorageState];
};
